<ion-content>
  <div class="kt-oldal">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Besorolás / átsorolás két táblával</ion-card-title>
        <ion-card-subtitle>
          Balra a forrás, jobbra a cél – a kijelölt tanulók egy gombnyomással mennek át, a megadott naptól.
          <ng-container *ngIf="munkatanev"> Tanév: {{ munkatanev }}/{{ munkatanev + 1 }}.</ng-container>
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <div class="kt-ures" *ngIf="jogBetoltve && !csoportJog && !osztalyJog">
          Ehhez a képernyőhöz nincs jogosultságod (a csoport- vagy az osztálybesorolás joga kell).
        </div>

        <ng-container *ngIf="csoportJog || osztalyJog">
          <ion-segment [(ngModel)]="mod" (ionChange)="modValtas()">
            <ion-segment-button value="csoport" [disabled]="!csoportJog">
              <ion-label>Csoportba sorolás</ion-label>
            </ion-segment-button>
            <ion-segment-button value="osztaly" [disabled]="!osztalyJog">
              <ion-label>Osztályba sorolás</ion-label>
            </ion-segment-button>
          </ion-segment>

          <div class="kt-beallitas">
            <ion-input type="date" fill="outline" label-placement="stacked"
                       label="Belépés / átsorolás / kilépés napja"
                       [min]="tanevHatar?.min || '1900-01-01'" [max]="tanevHatar?.max || '9999-12-31'"
                       [(ngModel)]="datum"></ion-input>
            <ion-checkbox *ngIf="mod === 'csoport' && bal.egyseg?.tipus === 'csoport'" [(ngModel)]="forrasbanMarad"
                          labelPlacement="end">
              A forráscsoportban is marad (csak hozzáadás)
            </ion-checkbox>
            <ion-checkbox *ngIf="mod === 'osztaly'" [(ngModel)]="csoportokkal" labelPlacement="end">
              A régi osztályhoz tartozó csoportok is (lezárás, és ha van egyértelmű pár a célosztályban, oda)
            </ion-checkbox>
            <ion-note color="medium">
              Az új tagság a megadott naptól él; a régi tagság a megadott nap előtti nappal zárul (az utolsó
              nap az előző nap). A korábbi névsor és a hozzá tartozó adatok megmaradnak.
              <ng-container *ngIf="mod === 'osztaly'">
                Az osztályból kisorolt tanuló osztály nélkül az intézmény tanulója marad – a távozó tanulóhoz a
                Kiléptetés való. Egy tanuló teljes, csoportonként egyeztetett átsorolása továbbra is az
                Átsorolás képernyőn végezhető.
              </ng-container>
            </ion-note>
          </div>

          <div class="kt-racs">
            <!-- ── Bal: forrás ── -->
            <section class="kt-tabla">
              <header>
                <span class="kt-cimke">Forrás</span>
                <ion-button fill="outline" size="small" (click)="forrasValasztas()">
                  <ion-icon slot="start" name="search-outline"></ion-icon>
                  {{ bal.egyseg?.nev || 'Válassz…' }}
                </ion-button>
              </header>
              <ng-container *ngTemplateOutlet="tablaTpl; context: { t: bal, balOldal: true }"></ng-container>
            </section>

            <!-- ── Középen: gombok ── -->
            <div class="kt-gombok">
              <ion-button color="success" (click)="jobbra()"
                          [disabled]="fut || !jobb.egyseg || !jeloltek(bal).length">
                {{ jobbraFelirat }} ({{ jeloltek(bal).length }})
                <ion-icon slot="end" name="arrow-forward-outline"></ion-icon>
              </ion-button>
              <ion-button color="warning" (click)="balra()"
                          [disabled]="fut || !jobb.egyseg || !jeloltek(jobb).length">
                <ion-icon slot="start" name="arrow-back-outline"></ion-icon>
                {{ balraFelirat }} ({{ jeloltek(jobb).length }})
              </ion-button>
              <ion-spinner *ngIf="fut" name="crescent"></ion-spinner>
            </div>

            <!-- ── Jobb: cél ── -->
            <section class="kt-tabla">
              <header>
                <span class="kt-cimke">{{ mod === 'csoport' ? 'Célcsoport' : 'Célosztály' }}</span>
                <ion-button fill="outline" size="small" (click)="celValasztas()">
                  <ion-icon slot="start" name="search-outline"></ion-icon>
                  {{ jobb.egyseg?.nev || 'Válassz…' }}
                </ion-button>
              </header>
              <ng-container *ngIf="jobb.egyseg; else nincsCel">
                <ng-container *ngTemplateOutlet="tablaTpl; context: { t: jobb, balOldal: false }"></ng-container>
              </ng-container>
              <ng-template #nincsCel>
                <div class="kt-ures">Válaszd ki, {{ mod === 'csoport' ? 'melyik csoportba' : 'melyik osztályba' }} sorolsz.</div>
              </ng-template>
            </section>
          </div>
        </ng-container>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>

<ng-template #tablaTpl let-t="t" let-balOldal="balOldal">
  <ion-searchbar [(ngModel)]="t.kereses" placeholder="Név, oktatási azonosító vagy osztály" [debounce]="150"></ion-searchbar>
  <ion-progress-bar type="indeterminate" *ngIf="t.betolt"></ion-progress-bar>
  <div class="kt-lista">
    <table>
      <thead>
        <tr>
          <th class="kt-jel">
            <ion-checkbox [checked]="osszesJelolt(t)" (ionChange)="osszesJelolese(t, $event.detail.checked)"
                          aria-label="Összes látható kijelölése"></ion-checkbox>
          </th>
          <th>Név</th>
          <th>Osztály</th>
          <th>{{ t.egyseg?.tipus === 'nincs-csoport' ? 'Csoportok' : 'Tag' }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let s of szurt(t)" [class.kt-tiltott]="balOldal && celbanVan(s)" (click)="sorKattintas(s, balOldal)">
          <td class="kt-jel">
            <ion-checkbox [(ngModel)]="s.jelolt" [disabled]="balOldal && celbanVan(s)"
                          (click)="$event.stopPropagation()" [attr.aria-label]="s.nev"></ion-checkbox>
          </td>
          <td>
            <div>{{ s.nev }}</div>
            <small>{{ s.oktazon }}</small>
          </td>
          <td>{{ s.osztaly || '—' }}</td>
          <td class="kt-miota">
            <ng-container *ngIf="balOldal && celbanVan(s)"><span class="kt-jelveny">már a célban</span></ng-container>
            <ng-container *ngIf="!(balOldal && celbanVan(s))">
              <ng-container *ngIf="t.egyseg?.tipus === 'nincs-csoport'; else tagsagTpl">{{ s.csoport_db || 0 }}</ng-container>
              <ng-template #tagsagTpl>
                <span *ngIf="s.kezdete">{{ s.kezdete }}-tól</span>
                <span *ngIf="s.vege"> {{ s.vege }}-ig</span>
                <span *ngIf="!s.kezdete && !s.vege">—</span>
              </ng-template>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="kt-ures" *ngIf="!t.betolt && !szurt(t).length">Nincs tanuló.</div>
  </div>
  <div class="kt-lab">{{ t.sorok.length }} tanuló · {{ jeloltek(t).length }} kijelölve</div>
</ng-template>
